module.exports = __webpack_public_path__ + "img/jiaoyu_xibeinonglin_1.00c57f5a.png";